export const LiveRideStatus = {
    ON_WAY_TOWARDS_PICKUP: "ON_WAY_TOWARDS_PICKUP",
    PICKING_UP_PACKAGE: "PICKING_UP_PACKAGE",
    OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
    ON_WAY_TOWARDS_DESTINATION: "ON_WAY_TOWARDS_DESTINATION",
    ARRIVED: "ARRIVED"
}